import {clientI18n} from '../ClientI18n.ts'
import {GameColor} from '../GameColor.ts'
import {createSpanIn} from '../ui_utils/DomUtils.ts'
import {UIUtilsChat} from './UIUtilsChat.ts'
import {type FeedMessageData} from '@colonist/shared-types'

export class UIChatPostText {
    private text: string
    private readonly username?: string | undefined
    private readonly italics: boolean
    private readonly shouldColorAndBoldUsernames: boolean
    private readonly textColor: GameColor.Color

    private readonly isLog: boolean

    constructor(post: HTMLDivElement, chatData: FeedMessageData, textColor: GameColor.Color, isLog: boolean) {
        this.text = clientI18n.t(chatData.text.key, chatData.text.options)
        this.username = chatData.username
        this.italics = chatData.italics == true
        this.shouldColorAndBoldUsernames = chatData.colorAndBoldUsernames == true
        this.textColor = textColor
        this.isLog = isLog

        this.createTextInPost(post)
    }

    private createTextInPost(post: HTMLDivElement) {
        if(this.shouldColorAndBoldUsernames) this.text = UIUtilsChat.colorAndBoldUsernames(this.text)
        this.text = UIUtilsChat.replaceKeywordsWithImages(this.text)

        this.prefixWithUsername()

        const messageSpanClassName = this.italics ? ' italics' : ''
        const contentSpan = createSpanIn(post, messageSpanClassName, {key: 'strings:colonistCommon.utils.#buffer', options: {value: this.text, interpolation: {escapeValue: false}}})
        this.handleVPText(contentSpan)
    }

    private prefixWithUsername() {
        if(this.username == undefined || this.isLog) return

        this.text = UIUtilsChat.getHighlightedUsername(this.username) + ': ' + this.text
    }

    private handleVPText(contentSpan: HTMLSpanElement) {
        const vpText = contentSpan.getElementsByClassName('vp-text')[0] as HTMLElement
        if(vpText == undefined) return
        vpText.style.color = UIUtilsChat.getTextColor('' + this.username, GameColor.getColor(this.textColor))
    }
}
